import React from "react";
import { Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { locales } from "@/i18n";
import { useLingui } from "@lingui/react";
import { useLocation } from "react-router-dom";

const LanguageSelector: React.FC = () => {
  const { i18n } = useLingui();
  const location = useLocation();

  // Handle language change
  const handleLanguageChange = (event: SelectChangeEvent<string>) => {
    const lang = event.target.value as string;
    localStorage.setItem("lang", lang);
    const segments = location.pathname.split("/");
    segments[1] = lang;
    const newPath = `${segments.join("/")}${location.search}${location.hash}`;
    window.location.href = newPath;
  };

  return (
    <Select
      variant="standard"
      sx={{
        fontWeight: 500,
        willChange: "transform",
      }}
      disableUnderline
      value={i18n.locale}
      onChange={handleLanguageChange}
    >
      {Object.entries(locales).map(([key, locale]) => (
        <MenuItem key={key} value={key}>
          {`${locale.flag} ${key.toUpperCase()}`}
        </MenuItem>
      ))}
    </Select>
  );
};

export default LanguageSelector;
